import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// This hardcoded data is still used by other components. We will remove it later.
export const videosData = [
  { 
    id: '15-minute-yoga', 
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAHzWuhrV64Ecr1vdUdB3Gp9RtoovpFMmRpxSM29qtB7G00Ph_AJ4Qvjs00WwIuM4kr7_HbdVmEAiatKn7SdO-8agmwsEGcukHIeHeYFi8QHOsyeZdIvmZf0kkAIz7Qjffh8WaWI9n4UJ2AjSI1CW9LOwPnVARyX1ZvX5HQcAKjO4Zo3ZoSaofXlof7dWj5lZApo57sNeiyn9uMt880zVT1EDmQswZNNyAB2h6qZD3JHZuai93Qnjx_2zGTvNVG44wjffB96dkAI4SZ', 
    title: '15-Minute Morning Yoga Flow', 
    shortDescription: 'Start your day with this energizing yoga sequence.', 
    category: 'Yoga',
    likes: 123,
    bookmarks: 45,
    comments: [{ name: 'Julia', text: 'This was the perfect start to my morning. Thank you!' }],
    shares: 89
  },
  // ... other videos
];

// We use this static object to assign images to the categories fetched from the backend.
const categoryVisuals = {
    Yoga: { image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=920&auto=format&fit=crop' },
    Nutrition: { image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?q=80&w=870&auto=format&fit=crop' },
    Meditation: { image: 'https://images.unsplash.com/photo-1506126613408-4e05960274e5?q=80&w=870&auto=format&fit=crop' },
    Fitness: { image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=870&auto=format&fit=crop' },
    Default: { image: 'https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?q=80&w=870&auto=format&fit=crop' }
};

const Videos = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const apiUrl = '/api/summary/videos_counts_cat';

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const formattedCategories = data.map(cat => ({
          ...cat, // Contains 'category' and 'count' from backend
          image: categoryVisuals[cat.category]?.image || categoryVisuals.Default.image
        }));
        setCategories(formattedCategories);
      })
      .catch(error => console.error('Error fetching video categories:', error));
  }, []);

  return (
    <div className="category-grid">
      {categories.map((category, index) => (
        <Link to={`/videos/category/${category.category}`} key={index} className="category-card-link">
          <div className="category-card" style={{ backgroundImage: `url(${category.image})` }}>
            <div className="category-card-overlay">
              <h3 className="category-card-title">{category.category} ({category.count})</h3>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Videos;
